var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_76300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3963 0.665576C8.51794 0.766094 8.53506 0.946187 8.43454 1.06782L3.4574 7.09068L3.45671 7.09151C3.3752 7.18939 3.2729 7.26787 3.15725 7.32125C3.04159 7.37463 2.9155 7.40156 2.78814 7.40009L2.78788 7.40008C2.65843 7.39847 2.53103 7.36756 2.41524 7.30966C2.29969 7.25189 2.19871 7.16875 2.11982 7.06646C2.11965 7.06624 2.11948 7.06602 2.11931 7.0658L0.560198 5.06123C0.463321 4.93668 0.485759 4.75717 0.610316 4.66029C0.734872 4.56341 0.91438 4.58585 1.01126 4.71041L2.57215 6.71727C2.59847 6.75147 2.63219 6.77926 2.67079 6.79856C2.70933 6.81783 2.75173 6.82813 2.79481 6.8287C2.83725 6.82918 2.87925 6.8202 2.91778 6.80242C2.9562 6.78469 2.99019 6.75865 3.01731 6.72619C3.01741 6.72607 3.01751 6.72596 3.0176 6.72584L7.99406 0.703816C8.09457 0.582179 8.27467 0.565058 8.3963 0.665576Z",
    fill: "#14763E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_76300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4641c2389d566afacd5378a8a4b597ad.svg";
export { ForwardRef as ReactComponent };